import { render, staticRenderFns } from "./medicine.vue?vue&type=template&id=142357cc&scoped=true&"
import script from "./medicine.vue?vue&type=script&lang=js&"
export * from "./medicine.vue?vue&type=script&lang=js&"
import style0 from "./medicine.vue?vue&type=style&index=0&id=142357cc&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142357cc",
  null
  
)

component.options.__file = "medicine.vue"
export default component.exports